<template>
  <span :aria-hidden="decorative"
        :aria-label="title"
        class="material-design-icon account-icon"
        role="img">

    <!-- <svg :fill="fillColor"
         class="material-design-icon__svg"
         :width="size"
         :height="size"
         viewBox="0 0 24 24">
      <path d="M12,4C14.21,4 16,5.79 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z">
        <title>{{ title }}</title>
      </path>
    </svg> -->

    <svg class="material-design-icon__svg" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="27.5 28.414 34.701 23.368"><g :fill="fillColor"><path d="M56.361 39.858v.362c0 2.498-.004 4.995.006 7.493 0 .207-.1.404-.27.522-2.544 1.772-5.344 2.912-8.412 3.339-5.161.717-9.89-.43-14.166-3.411-.095-.066-.187-.216-.187-.327-.01-2.596-.008-5.189-.007-7.785 0-.041.009-.083.018-.159l.735.258c2.497.891 4.995 1.778 7.49 2.674a9.578 9.578 0 006.466 0c2.642-.949 5.285-1.891 7.928-2.835l.175-.059.224-.072zM46.248 28.651a4700.39 4700.39 0 0115.123 5.373c.734.263 1.008.831.715 1.455-.147.314-.425.437-.724.543l-8.329 2.96c-2.533.9-3.722 1.313-6.252 2.222-1.545.535-2.594.497-4.301-.176-5.317-1.896-8.775-3.115-14.093-5.011-.243-.087-.505-.224-.665-.416a.907.907 0 01.31-1.421c.443-.214.917-.365 1.383-.532a3501.106 3501.106 0 0114.059-4.997 4.17 4.17 0 012.774 0zM60.389 38.427c0 1.319.004 2.588-.005 3.856-.001.221.054.364.235.514.654.539.712 1.572.154 2.27-.57.712-1.556.858-2.279.338a1.67 1.67 0 01-.283-2.49.79.79 0 00.212-.576c-.009-.979.001-1.958-.008-2.938-.002-.201.052-.302.257-.368.56-.18 1.111-.39 1.717-.606"/></g></svg>

  </span>
</template>

<script>
export default {
  name: "EducationIcon",
  props: {
    title: {
      type: String,
      default: "Education icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
